// hooks/useAdminMessagePolling.js
import { useEffect, useRef, useCallback } from 'react';
import { chatService } from '../../services/PlatformService';

export const useAdminMessagePolling = (chatId, conversationState, onNewMessages) => {
  const intervalRef = useRef(null);
  const lastMessageCountRef = useRef(0);

  const fetchNewMessages = useCallback(async () => {
    if (!chatId || conversationState !== 'paused') return;

    try {
      console.log('[Admin Polling] Buscando novas mensagens...');
      const result = await chatService.getChatMessages(chatId);
      
      if (result.messages && result.messages.length > lastMessageCountRef.current) {
        console.log(`[Admin Polling] ${result.messages.length - lastMessageCountRef.current} novas mensagens detectadas`);
        lastMessageCountRef.current = result.messages.length;
        
        if (onNewMessages) {
          onNewMessages(result);
        }
      }
    } catch (error) {
      console.error('[Admin Polling] Erro:', error);
    }
  }, [chatId, conversationState, onNewMessages]);

  useEffect(() => {
    // Limpar intervalo anterior
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    // Iniciar polling apenas se estiver em paused
    if (conversationState === 'paused' && chatId) {
      console.log('[Admin Polling] Iniciando polling para paused (5s)');
      
      // Buscar imediatamente
      fetchNewMessages();
      
      // Configurar intervalo de 5 segundos
      intervalRef.current = setInterval(fetchNewMessages, 5000);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [conversationState, chatId, fetchNewMessages]);

  return { syncNow: fetchNewMessages };
};